import { useTranslation } from 'react-i18next'


import { LinkForm } from '../components/Links/LinkForm'
import { PreviewBlock } from '../components/Links/previewBlock'


export const LinkPage = () => {
  const { t } = useTranslation()
  

  

  return (
    <div className="flex flex-col sm:flex-row">
      <div
        className="flex w-full flex-col items-center justify-start
       gap-[186px] sm:max-h-[calc(100vh_-89px)] sm:w-[50%] sm:overflow-scroll
       sm:border sm:border-r sm:border-gray-300"
      >
        <div
          className="mt-7 flex w-[350px] flex-col px-7
        pb-20 sm:ml-[100px] sm:w-[250px] sm:pb-16 lg:w-[350px] xl:w-[550px]"
        >
          <LinkForm />
        </div>
      </div>

      <div
        className="hidden w-[50%] items-center sm:flex"
        style={{ height: 'calc(100vh - 89px)' }}
      >
        <PreviewBlock />
      </div>
    </div>
  )
}
